/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-03-13 15:48:10
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\main.js
 * @Description: 
 */
'use strict';
let tolerantBaidumapurl = 'https://api.map.baidu.com/api?v=2.0&ak=XBZvck2xrFqllF83GWU8dNS3mZZOP273&callback=initialize';
let realBaidumapUrl = window.location.protocol.includes('https') ? tolerantBaidumapurl + '&s=1' : tolerantBaidumapurl;
require.config({
    // 配置echarts的路径
    paths: {
        echarts: './lib/echarts/dist/echarts',
        webuploader: './lib/webuploader/webuploader',
        ueditorConfig: './lib/ueditor2/ueditor.config.js?v=11.5',
        ueditor: './lib/ueditor2/ueditor.all.js?v=11.5',
        echartsWordcloud: './lib/echarts/dist/echarts-wordcloud.min',
        progress: './lib/nprogress/nprogress',
        imJson2: './lib/im/json2.min',
        webim: './lib/im/webim.min',
        sparkMd5: './lib/im/spark-md5', // im上传图片的md5加密库
        // promiseLimit:'./lib/trsAudioVideoUpload/promise-limit',
        // uploadJq: './lib/trsAudioVideoUpload/jquery',
        uploadMd5: './lib/generalUpLoad/md5',
        videoUpload: './lib/generalUpLoad/webuploader',
        JSEncrypt: './lib/jsencrypt/jsencrypt.min', // 密码加密库
        async: './lib/requirejs-plugins/src/async',
        generalUpLoad: './lib/generalUpLoad/src/upLoad',
        BMap: [realBaidumapUrl],

        /* echarts2: './lib/echarts-2.2.7/build/dist/echarts',
        pinyin: './lib/JSPinyinUtil/JSPinyin',
        mCustomScrollbar:"./lib/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar"*/
    },
    shim: {
        'BMap': {
            exports: 'BMap'
        }
    }
});
